import { render, staticRenderFns } from "./activityGiveList.vue?vue&type=template&id=c4fe2e00"
import script from "./activityGiveList.vue?vue&type=script&lang=js"
export * from "./activityGiveList.vue?vue&type=script&lang=js"
import style0 from "./activityGiveList.vue?vue&type=style&index=0&id=c4fe2e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports